import Dashboard from "./Dashboard";
import Institutions from "./Institutions";
import SubAdmins from "./SubAdmins";
import Transactions from "./Transactions";
import Configurations from "./Configurations";
import BalanceConfiguration from "./BalanceConfiguration";
import CreditHistory from "./CreditHistory";

export {
  Dashboard,
  Institutions,
  Transactions,
  SubAdmins,
  Configurations,
  BalanceConfiguration,
  CreditHistory,
};
